import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/brand";

export default function WhatsAppFab() {
  const url = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(BRAND.whatsappMsg)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chatta su WhatsApp"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 bg-[#25D366] rounded-full animate-pulse-ring" />
      <span className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] rounded-full shadow-[0_0_30px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform">
        <MessageCircle size={24} className="text-white" strokeWidth={2} />
      </span>
      <span className="absolute right-full top-1/2 -translate-y-1/2 mr-3 whitespace-nowrap bg-black/90 border border-white/10 text-white text-xs px-3 py-1.5 uppercase tracking-widest font-semibold opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        WhatsApp
      </span>
    </a>
  );
}
